/**
 * Coin object
 */
Game.Prefabs.Coin = function( game, x, y, group ) {

	// Setup Coin.
	Phaser.Sprite.call( this, game, x + Game.Utils.Map.TILE_HALF_SIZE, y + Game.Utils.Map.TILE_HALF_SIZE, 'coin' );

	// Add coin animations.
	this.animations.add( 'spin', [ 0, 1, 2, 3 ], 6, true );
	this.animations.add( 'explode',
		[
			0, 1, 2, 3,
			0, 1, 2, 3,
			4, 5, 6, 7, 8
		],
		30, false );

	// Set the anchor to the middle to center the coin on the tile.
	this.anchor.setTo( 0.5, 0.5 );

	// Play the spin animation by default.
	this.animations.play( 'spin' );

	// Add to the display group.
	group.add( this );

};


Game.Prefabs.Coin.prototype = Object.create( Phaser.Sprite.prototype );


Game.Prefabs.Coin.constructor = Game.Prefabs.Coin;


/**
 * Collect the coin
 *
 * Play collection anuimation and then remove the coin from the game.
 *
 * @param  {[type]} skier [description]
 * @return {[type]}       [description]
 */
Game.Prefabs.Coin.prototype.collect = function() {

	var animation = this.animations.play( 'explode' );
	this.bringToTop();
	this.alive = false;

	var tween = game.add.tween( this );
	tween.to( { y: this.y - 8 }, 200 );
	tween.start();

	// When the animation completes, kill the coin.
	animation.onComplete.add(
		this.kill,
		this
	);

};

